import fetch from './fetch';

type SubmitProps = {
	uri: string;
	node: string;
	csrfToken: string;
	data: any;
	onSuccess?: Function;
	onFail?: Function;
};
export default ({uri, node, csrfToken, data, onSuccess, onFail}: SubmitProps) => {
	(async () => {
		const response = await fetch(uri, {
			method: 'POST',
			credentials: 'include',
			headers: {
			  'Content-Type': 'application/x-www-form-urlencoded',
			  'X-CSRF-TOKEN': csrfToken
			},
			body: `nodeAggregateIdentifier=${node}&command=${encodeURIComponent(JSON.stringify(data))}`,
		});

		if (response.status === 200) {
			if (onSuccess) {
				onSuccess();
			}
		} else {
			if (onFail) {
				onFail();
			}
		}
	})();
}
